// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgVioIcon = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <g clipPath="url(#vioIcon_svg__a)">
      <path
        d="M5.232 4.597a4.02 4.02 0 0 0 5.144 2.387L9.107 3.516a.308.308 0 0 0-.394-.183l-3.48 1.264Z"
        fill="#9865FC"
      />
      <path
        d="M15.997 4.234c-.069-1.74-1.497-3.151-3.245-3.207-.15-.004-.3 0-.446.015l.32.881a1.7 1.7 0 0 1 1.553 1.688c0 .4-.14.767-.376 1.057a.646.646 0 0 1-.964.032l-.835-.883a.987.987 0 0 0-.715-.309H9.103l1.273 3.477a3.837 3.837 0 0 1-2.293.76 3.815 3.815 0 0 1-3.522-2.338C1.691 6.608 2.651 8.85.405 9.33c-.26.056-.405.037-.405.037l.206.565c1.253.024 2.074-.568 2.17-.656l2.078 5.699h2.205v-2.42c0-.187.166-.33.352-.303l2.205.33c.1.014.185.076.23.166l1.118 2.227h2.725l-2.354-6.45c.026.003.888.094 1.41-.216l-.94-.83c.384.152.8.236 1.238.236a3.35 3.35 0 0 0 3.354-3.48Zm-4.43 1.262a.287.287 0 1 1 0-.573.287.287 0 1 1 0 .573Z"
        fill="#7130C9"
      />
      <path
        d="M10.376 6.984a4.02 4.02 0 0 1-4.93-1.9l-.055.016c-.46.133-.83.307-.83.307a3.816 3.816 0 0 0 3.521 2.338c.857 0 1.656-.286 2.293-.76Z"
        fill="#3D0083"
      />
    </g>
    <defs>
      <clipPath id="vioIcon_svg__a">
        <path
          fill="#fff"
          transform="translate(0 1.026)"
          d="M0 0h16v13.949H0z"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgVioIcon
